import * as d3 from "d3";
import { THEMES } from "lib/constants";

const colorOptions = [
  ["gold", "pink", THEMES.PRIMARY.BLUE],
  ["gold", "pink", THEMES.PRIMARY.RED],
  ["gold", "pink", THEMES.PRIMARY.GREEN],
  ["gold", "pink", "yellow"],
  ["gold", "pink", "teal"],
  ["gold", "pink", "magenta"],
  ["gold", "pink", "cyan"],
  ["gold", THEMES.PRIMARY.BLUE, THEMES.PRIMARY.RED],
  ["gold", THEMES.PRIMARY.BLUE, THEMES.PRIMARY.GREEN],
  ["gold", THEMES.PRIMARY.BLUE, "yellow"],
  ["gold", THEMES.PRIMARY.BLUE, "teal"],
  ["gold", THEMES.PRIMARY.BLUE, "magenta"],
  ["gold", THEMES.PRIMARY.BLUE, "cyan"],
  ["gold", THEMES.PRIMARY.RED, THEMES.PRIMARY.GREEN],
  ["gold", THEMES.PRIMARY.RED, "yellow"],
  ["gold", THEMES.PRIMARY.RED, "teal"],
  ["gold", THEMES.PRIMARY.RED, "magenta"],
  ["gold", THEMES.PRIMARY.RED, "cyan"],
  ["gold", THEMES.PRIMARY.GREEN, "yellow"],
  ["gold", THEMES.PRIMARY.GREEN, "teal"],
  ["gold", THEMES.PRIMARY.GREEN, "magenta"],
  ["gold", THEMES.PRIMARY.GREEN, "cyan"],
  ["gold", "yellow", "teal"],
  ["gold", "yellow", "magenta"],
  ["gold", "yellow", "cyan"],
  ["gold", "teal", "magenta"],
  ["gold", "teal", "cyan"],
  ["pink", THEMES.PRIMARY.BLUE, THEMES.PRIMARY.RED],
  ["pink", THEMES.PRIMARY.BLUE, THEMES.PRIMARY.GREEN],
  ["pink", THEMES.PRIMARY.BLUE, "yellow"],
  ["pink", THEMES.PRIMARY.BLUE, "teal"],
  ["pink", THEMES.PRIMARY.BLUE, "magenta"],
  ["pink", THEMES.PRIMARY.BLUE, "cyan"],
  ["pink", THEMES.PRIMARY.RED, THEMES.PRIMARY.GREEN],
  ["pink", THEMES.PRIMARY.RED, "yellow"],
  ["pink", THEMES.PRIMARY.RED, "teal"],
  ["pink", THEMES.PRIMARY.RED, "magenta"],
  ["pink", THEMES.PRIMARY.RED, "cyan"],
  ["pink", THEMES.PRIMARY.GREEN, "yellow"],
  ["pink", THEMES.PRIMARY.GREEN, "teal"],
  ["pink", THEMES.PRIMARY.GREEN, "magenta"],
  ["pink", THEMES.PRIMARY.GREEN, "cyan"],
  ["pink", "yellow", "teal"],
  ["pink", "yellow", "magenta"],
  ["pink", "yellow", "cyan"],
  ["pink", "teal", "magenta"],
  ["pink", "teal", "cyan"],
  [THEMES.PRIMARY.BLUE, THEMES.PRIMARY.RED, THEMES.PRIMARY.GREEN],
  [THEMES.PRIMARY.BLUE, THEMES.PRIMARY.RED, "yellow"],
  [THEMES.PRIMARY.BLUE, THEMES.PRIMARY.RED, "teal"],
  [THEMES.PRIMARY.BLUE, THEMES.PRIMARY.RED, "magenta"],
  [THEMES.PRIMARY.BLUE, THEMES.PRIMARY.RED, "cyan"],
  [THEMES.PRIMARY.BLUE, THEMES.PRIMARY.GREEN, "yellow"],
  [THEMES.PRIMARY.BLUE, THEMES.PRIMARY.GREEN, "teal"],
  [THEMES.PRIMARY.BLUE, THEMES.PRIMARY.GREEN, "magenta"],
  [THEMES.PRIMARY.BLUE, THEMES.PRIMARY.GREEN, "cyan"],
  [THEMES.PRIMARY.BLUE, "yellow", "teal"],
  [THEMES.PRIMARY.BLUE, "yellow", "magenta"],
  [THEMES.PRIMARY.BLUE, "yellow", "cyan"],
  [THEMES.PRIMARY.BLUE, "teal", "magenta"],
  [THEMES.PRIMARY.BLUE, "teal", "cyan"],
];

const computedColorCache = {};

export const rgbToHex = (rgbString) => {
  const regex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;
  const match = rgbString.match(regex);

  if (match) {
    const r = parseInt(match[1], 10);
    const g = parseInt(match[2], 10);
    const b = parseInt(match[3], 10);

    const hexR = r.toString(16).padStart(2, "0");
    const hexG = g.toString(16).padStart(2, "0");
    const hexB = b.toString(16).padStart(2, "0");

    return `#${hexR}${hexG}${hexB}`;
  }
  return "#000";
};

export const generateIndexFromString = (str) => {
  if (str) {
    let hash = 0;
    for (let i = 0; i < str.length; i += 1) {
      // eslint-disable-next-line no-bitwise
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    const positiveHash = Math.abs(hash);
    const randomFloat = positiveHash / Number.MAX_SAFE_INTEGER;
    return randomFloat;
  }
  return 0.5;
};

export const generateColorFromString = (str) => {
  if (!str) return "#000";
  if (computedColorCache[str]) return computedColorCache[str];

  const computedModifier =
    str.split("").reduce((modifier, char) => {
      const newSumModifier = modifier + char.charCodeAt(0);
      return newSumModifier;
    }, 0) % 61;

  const index = generateIndexFromString(str) * 1e6;
  const color = d3.piecewise(d3.interpolateRgb.gamma(2.2), colorOptions[computedModifier])(index);
  const convertedToHex = rgbToHex(color);
  computedColorCache[str] = convertedToHex;
  return convertedToHex;
};

export const hexToRgba = (hex, opacity) => {
  hex = hex.replace(/^#/, "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
